import AntIcon from '@expo/vector-icons/AntDesign';
import React from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';
import { Constants } from 'src/constants/constants';
import { AppColors } from 'src/themes/Colors';
import { fontSizes, iconSize, metrics } from 'src/themes/Metrics';
import styled from 'styled-components/native';

import { Container } from './Container';
import { RegularText } from './RegularText';
import { Row } from './Row';
import { SizedBox } from './SizedBox';

const Styled = {
  OuterWrapper: styled.View`
    margin-bottom: ${metrics.medium}px;
  `,
  Wrapper: styled(TouchableOpacity)`
    height: ${metrics.inputHeight}px;
    padding: ${metrics.medium}px;
    padding-bottom: ${metrics.small}px;
    border-radius: ${metrics.borderRadius}px;
  `,
  // border-width: ${StyleSheet.hairlineWidth}px;
  // border-color: ${AppColors.border};
};

interface Props {
  label?: string;
  labelLang?: string;
  value: any;
  onChange(data: any): void;
  placeholderLang?: string;
  onPress?(): void;
  clearValue?: number | string | null;
  clearButton?: boolean;
  iconLeft?: any;
  labelWrapperStyle?: StyleProp<ViewStyle>;
  row?: boolean;
  isRequire?: boolean;
  disabled?: boolean;
  error?: string;
}
export const ButtonInput = ({
  value = '',
  labelWrapperStyle = null,
  iconLeft = null,
  onChange = () => {},
  onPress = () => {},
  clearValue = '',
  label,
  labelLang,
  placeholderLang,
  row,
  clearButton,
  isRequire,
  disabled,
  error,
}: Props) => {
  return (
    <Styled.OuterWrapper style={row ? { flex: 1 } : { width: '100%' }}>
      <Styled.Wrapper activeOpacity={Constants.ACTIVE_OPACITY} disabled={disabled} onPress={onPress}>
        <Row>
          <RegularText color={AppColors.gray} fontSize="small" style={labelWrapperStyle} textLang={labelLang}>
            {label}
          </RegularText>
          <SizedBox width="tiny" />
          {isRequire ? (
            <RegularText color={AppColors.red} fontSize="medium">
              *
            </RegularText>
          ) : (
            <View />
          )}
        </Row>
        <Row flex>
          {iconLeft != null ? <View style={[styles.iconWrapper]}>{iconLeft}</View> : <View />}
          <Container flex align="middle">
            {value ? (
              <RegularText fontSize="medium" style={labelWrapperStyle}>
                {value}
              </RegularText>
            ) : (
              <RegularText
                color={AppColors.gray}
                fontSize="medium"
                style={labelWrapperStyle}
                textLang={placeholderLang}
              />
            )}
          </Container>
          {clearButton && value ? (
            <TouchableOpacity
              onPress={() => onChange(clearValue)}
              style={[styles.iconWrapper]}
              hitSlop={{ top: 10, right: 10, bottom: 5, left: 10 }}>
              <AntIcon name="close" size={iconSize.medium} color="#707070" />
            </TouchableOpacity>
          ) : (
            <View />
          )}
        </Row>
      </Styled.Wrapper>
      {error && (
        <RegularText style={{ marginTop: metrics.small }} textAlign="left" color={AppColors.red} fontSize="small">
          {error}
        </RegularText>
      )}
    </Styled.OuterWrapper>
  );
};

const styles = StyleSheet.create({
  iconWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputStyle: {
    fontSize: fontSizes.medium,
    flex: 1,
  },
});
